import styled from '@emotion/styled'
import { NavLink } from 'react-router-dom'

export const Container = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  margin: 0 5%;
  height: 440px;

  @media (max-width: 768px) {
    flex-direction: column;
    height: 100%;
    margin-bottom: 5rem;
    margin-top: 400px;
  }
`

export const PosContent = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  border-radius: 24px;
  padding: 30px 10px;
  width: 45%;
  align-items: center;
  position: relative;

  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 5rem;
  }
`

export const BridgeContent = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  border-radius: 24px;
  padding: 30px 10px;
  width: 45%;
  align-items: center;
  position: relative;

  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 5rem;
  }
`

export const Title = styled.p<{
  color: string
}>`
  font-size: 24px;
  font-family: Inter-Black, Inter;
  font-weight: 400;
  line-height: 28px;
  margin-bottom: 0px;
  color: ${({ color }) => color};
`

export const StyledNavLink = styled(NavLink)`
  outline: none;
  text-decoration: none;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  height: 60px;
  line-height: 60px;
  position: absolute;
  bottom: -30px;
`

export const PosData = styled.div`
  font-size: 5rem;
  font-family: Inter-Black, Inter;
  font-weight: 900;
  color: #0f68aa;
`

export const BridgeData = styled.div`
  font-size: 5rem;
  font-family: Inter-Black, Inter;
  font-weight: 900;
  color: #2fbdf4;
`

export const Description = styled.div`
  font-size: 16px;
  font-family: Inter-Regular, Inter;
  font-weight: 400;
  line-height: 19px;
  width: 95%;
  color: #818d96;
`

export const Text1 = styled.div`
  font-size: 14px;
  font-family: Inter-Black, Inter;
  font-weight: 400;
  color: #818d96;
  margin-bottom: 1rem;
`

export const LogoCon = styled.div`
  width: 100%;
`

export const BtnLink = styled.div`
  width: 80%;
  background-color: #0f68aa;
  border-radius: 16px;
  color: #fff;
`

export const Img = styled.img`
  display: inline-block;
`

export const POS_Description = `Receive staking rewards by delegating your WAN to Wanchain PoS nodes.Your delegated WAN contributes to the overall stability and security of the Wanchain blockchain network.`

export const BRIDGE_Description = `Receive staking rewards by delegating your WAN to Wanchain Bridge nodes. Your delegated WAN enhances the bandwidth, security and stability of Wanchain's cross-chain bridges.`
